import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Input } from 'antd';
import { getCohortSearch } from 'actions/superuser';
import { Parser } from 'json2csv';

import './CohortSearch.css';
import moment from 'moment';

const Search = Input.Search;

function mapState(state) {
  return {
    ...state.superuser
  };
}

function mapDispatch(dispatch, props) {
  return {
    getCohortSearch(data) {
      return getCohortSearch(dispatch, data);
    }
  };
}

class CohortSearch extends Component {

  static propTypes = {
    getCohortSearch: React.PropTypes.func,
    cohortSearch: React.PropTypes.object
  };


  get pageTitle() {
    return 'Cohort search';
  }

  downloadTxtFile = data => {
    const fields = ['sort_by', 'service', 'last updated', 'userEmail', 'date', 'transactionId', 'value', 'psychicEmail'];
    const json2csvParser = new Parser({ fields });

    const fulfilledRows = data.transactionsArray.map(i => ({
      ...i,
      value: i.value / 100,
      sort_by: data.searchTerm,
      service: data.serviceName,
      'last updated': data.updatedAt
    }));
    const csvOutput = json2csvParser.parse(fulfilledRows);

    const element = document.createElement('a');
    const file = new Blob([csvOutput], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = `${ data.serviceName }_${ data.searchTerm }_${ moment().format('YYYY-MM-DD') }.csv`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  render() {
    const { cohortSearch } = this.props;
    const transactionsArray = cohortSearch ? cohortSearch.transactionsArray : [];
    const paidTransactionsArray = transactionsArray.filter(i => i.transactionId);
    const users = [...new Set(transactionsArray.map(i => i.userEmail))];
    const revenue = transactionsArray.reduce((a, b) => a + b.value, 0);
    const thisSaturday = moment().day(6).startOf('day');
    const prevSaturday = moment().day(-6).startOf('day');
    const today = moment().startOf('day');
    const updatedAt = (today < thisSaturday ? prevSaturday : thisSaturday).format('YYYY-MM-DD');
    return (
      <div className="p-20">
        <div className="page-title">{ this.pageTitle }</div>
        <Search
          placeholder="input exact 'sortBy' value"
          onSearch={ value => this.props.getCohortSearch({ searchTerm: value }) }
          size="large"
          enterButton="Search"
        />
        { transactionsArray.length ?
          <div className="resultSection">
            <div>
              Title: Cohort search sort_by = { cohortSearch.searchTerm }
            </div>
            <div>
              Service: { cohortSearch.serviceName }
            </div>
            <div>
              Last Updated: { updatedAt }
            </div>
            <div>
              # of Users: { users.length }
            </div>
            <div>
              # of Transactions: { transactionsArray.length }
            </div>
            <div>
              # of Paid Transactions: { paidTransactionsArray.length }
            </div>
            <div>
              revenue = ${ revenue / 100 }
            </div>
            <Button type="primary" onClick={ () => this.downloadTxtFile({ ...cohortSearch, updatedAt }) }>Download
              csv</Button>
          </div> :
          <div className="no-user">no data found</div>
        }
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(CohortSearch));



// WEBPACK FOOTER //
// ./src/pages/cohort_search/CohortSearch.jsx